export type SelectionTextStyleAttr = 'fontSize' | 'fontFamily';

interface SelectionEditor {
	state: {
		selection: { from: number; to: number; empty: boolean };
		doc: {
			nodesBetween: (
				from: number,
				to: number,
				callback: (node: SelectionNode) => void,
			) => void;
		};
	};
	getAttributes: (name: string) => Record<string, unknown>;
}

interface SelectionNode {
	isText?: boolean;
	text?: string | null;
	marks?: readonly { type: { name: string }; attrs: Record<string, unknown> }[];
}

function normalize(attr: SelectionTextStyleAttr, value: string): string {
	if (attr === 'fontSize') return value.replace(/px$/i, '').trim();
	return value
		.split(',')[0]
		.trim()
		.replace(/^['"]|['"]$/g, '');
}

// The value the selection renders in: one value when every text run agrees, '' when mixed or empty.
export function getSelectionTextStyle(
	editor: SelectionEditor,
	attr: SelectionTextStyleAttr,
	blockDefault: string,
): string {
	const { from, to, empty } = editor.state.selection;
	if (empty) {
		return normalize(
			attr,
			String(editor.getAttributes('textStyle')[attr] || blockDefault || ''),
		);
	}

	const values = new Set<string>();
	editor.state.doc.nodesBetween(from, to, node => {
		if (!node.isText || !node.text) return;
		const mark = node.marks?.find(m => m.type.name === 'textStyle');
		values.add(normalize(attr, String(mark?.attrs?.[attr] || blockDefault || '')));
	});

	return values.size === 1 ? [...values][0] : '';
}
